import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { UserauthRealmAccessTable } from '../../../../../../features/userauth/realm-access/userauth-realm-access-table';
import type { RouteGuardOptions } from '../../../../../../util/routing/guard';
import { getPageHead } from '../../../../../../util/routing/meta';
import { usePlatformWorkspaceRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_platform/_context-required/realm-access/_realm-access/')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Platform] } },
  } as const satisfies RouteGuardOptions,
  shouldReload: true,
  preload: false,
  head: () => getPageHead('Realm Access'),
  component: RealmAccessList,
});

function RealmAccessList() {
  const viewCtx = usePlatformWorkspaceRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <UserauthRealmAccessTable viewContext={viewCtx} />
      </PageLayout.Section>
    </PageLayout>
  );
}
